import methods from './methods';

export default {
    install(Vue) {
        Object.keys(methods).forEach(key => {
            if (!Vue.prototype[`$${key}`]) {
                Vue.prototype[`$${key}`] = methods[key];
            } else {
                console.warn(`$${key}方法重复`);
            }
        });
    },
};
